import { Link } from 'react-router-dom';
import { Link2 } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import type { SyncedLocation } from '@/types/api';

interface LocationPartnerLineProps {
  partnerAccount: SyncedLocation['partnerAccount'];
}

/** The owning partner account on the detail page header (FR-181). Bridge-only; never published. */
export function LocationPartnerLine({ partnerAccount }: LocationPartnerLineProps): JSX.Element {
  return (
    <span className="flex flex-wrap items-center gap-1" data-testid="location-partner">
      <Link2 className="h-3 w-3" aria-hidden="true" />
      {partnerAccount ? (
        <>
          <Link
            to={`/partner-accounts/${partnerAccount.id}`}
            className="font-medium text-foreground hover:underline"
            data-testid="location-partner-link"
          >
            {partnerAccount.name}
          </Link>
          {partnerAccount.partnerType?.name && <span>({partnerAccount.partnerType.name})</span>}
          {!partnerAccount.enabled && (
            <Badge variant="outline" className="px-1.5 py-0 text-[10px]" data-testid="location-partner-disabled">
              Disabled
            </Badge>
          )}
        </>
      ) : (
        <span>Unknown partner</span>
      )}
    </span>
  );
}
